import httpUtils from '../../utils/HttpUtils'

class QuestionService {

  //获取问题列表信息
  async list(keyword = '',pageNo = 1) {
    let result = null;
    try {
      result = await httpUtils.post('/qa/question/list',{keyword,pageNo})
    } catch (error) {
      console.log('连接失败', e);
      result = {code: 1, msg: '连接失败'};
    }
    return result
  }

  //获取我发布的问题列表信息
  async publishList(pageNo = 1) {
    let result = null;
    try {
      result = await httpUtils.post('/qa/question/publish/list',{pageNo})
    } catch (error) {
      console.log('连接失败', e);
      result = {code: 1, msg: '连接失败'};
    }
    return result
  }


  //获取问题详情信息
  async detail(id = '') {
    let result = null;
    try {
      result = await httpUtils.post('/qa/question/detail',{id})
    } catch (error) {
      console.log('连接失败', e);
      result = {code: 1, msg: '连接失败'};
    }
    return result
  }

  //获取问题详情信息
  async remove(id = '') {
    let result = null;
    try {
      result = await httpUtils.post('/qa/question/remove',{id})
    } catch (error) {
      console.log('连接失败', e);
      result = {code: 1, msg: '连接失败'};
    }
    return result
  }

  //保存问题信息
  async save(question) {
    let result = null;
    try {
      result = await httpUtils.post('/qa/question/save',question)
    } catch (error) {
      console.log('连接失败', e);
      result = {code: 1, msg: '连接失败'};
    }
    return result
  }

}
export default new QuestionService()
